import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes, AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
let LogotypeImageResolution = class LogotypeImageResolution {
    constructor(params = {}) {
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, context: 1, implicit: true })
], LogotypeImageResolution.prototype, "numBits", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer, context: 2, implicit: true })
], LogotypeImageResolution.prototype, "tableSize", void 0);
LogotypeImageResolution = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], LogotypeImageResolution);
export { LogotypeImageResolution };
